// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Introduced in TP-9489.
type MetaData<TResponseData = undefined> = {
	message: string;
	status: number;
	data?: TResponseData;
};

export default class RequestError<TResponseData = undefined> extends Error {
	status: number;
	data: TResponseData | undefined;

	constructor({ message, status, data }: MetaData<TResponseData>) {
		super(message);

		this.status = status;
		this.data = data;
	}
}
